<template>
    <div>
		<Modal :open-state="show" @close="() => show = false">
			<div>
				<div class="fields__item">
					<div class="settings__row">
						<div class="settings__col">
							<div class="settings__theme">
								<h6 class="settings__theme-title">Темная тема</h6>
								<label class="switch settings__theme-switch">
									<input class="switch__input" v-model="$root.darkTheme" autocomplete="off" type="checkbox">
									<span class="switch__btn"></span>
								</label>
							</div>
						</div>
						<div v-if="user.rang" class="settings__col">
							<h6 class="settings__rang">Ваш ранг: <router-link :to="{name: 'rang'}" class="settings__rang-link" target="_blank"> {{ user.rang.title }} </router-link></h6>
						</div>
					</div>
				</div>
				<div class="fields__item">
					<h6>Для вывода нужно отыграть: {{user && user.wager}}</h6>
				</div>
				<hr>
				<div class="fields__item" v-if="!this.user.old_username">
					<h6>Смена ника</h6>
					<div class="fields__row">
						<div class="fields__col">
							<input type="text" v-model="username" name="username" class="text-field__input" placeholder="Новый ник" autocomplete="off" required="">
							<span class="text-field__error" v-if="errors1.show">
								{{ errors1.message }}
							</span>
							<span class="text-field__success" v-if="successChangeNick">
								Ник изменен
							</span>
						</div>
						<div class="fields__col">
							<button @click="editUser" class="btn btn--block btn--primary" :disabled="disableBtn1">Сменить</button>
						</div>
					</div>
				</div>

				<div class="fields__item" v-if="user.has_password">
					<h6>Смена пароля</h6>
					<div class="fields__row fields__item">
						<div class="fields__col">
							<input type="password" v-model="oldPassword" name="firstname" class="text-field__input" placeholder="Старый пароль" autocomplete="off" required="">
						</div>
						<div class="fields__col">
							<input type="password" v-model="newPassword" name="lastname" class="text-field__input" placeholder="Новый пароль" autocomplete="off" required="">
							<span class="text-field__error" v-if="errors.show"> {{ errors.message }}</span>
							<span class="text-field__success" v-if="successChangePassword">Пароль изменен</span>
						</div>
					</div>
					<div class="fields__item">
						<button @click="resetPassword" class="btn btn--block btn--primary" :disabled="disableBtn">Сохранить</button>
					</div>
				</div>

				<div class="fields__item" v-if="!user.has_password">
					<h6>Установить пароль</h6>
					<div class="fields__row">
						<div class="fields__col">
							<input type="password" v-model="setPass" name="firstname" class="text-field__input " placeholder="Новый пароль" autocomplete="off" data-parsley-class-handler="#fnWrapper" required="">
							<span class="text-field__error" v-if="errors2.show"> {{ errors2.message }}</span>
							<span class="text-field__success" v-if="successSetPass">Пароль установлен</span>
						</div>
						<div class="fields__col">
							<button @click="setPassword" class="btn btn--block btn--primary tx-normal rpbss" :disabled="disableBtn2">Сохранить</button>
						</div>
					</div>
				</div>
				<hr>
				<div class="fields__item">
					<button v-if="user.vkontakte" class="btn btn--lg btn--outline-vkontakte btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
						{{ user.vkontakte.full_name ? user.vkontakte.full_name : user.vkontakte.username }}
					</button>
					<button v-if="!user.vkontakte" @click="$root.OAuth('vkontakte')" class="btn btn--lg btn--outline-vkontakte btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
						Привязать Вконтакте
					</button>
				</div>
				<hr>
				<div class="fields__item">
					<button v-if="user.telegram" class="btn btn--lg btn--outline-telegram btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
						{{ user.telegram.full_name ? user.telegram.full_name : user.telegram.username }}
					</button>
					<button v-if="!user.telegram" @click="$root.OAuth('telegram')" class="btn btn--lg btn--outline-telegram btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
						Привязать Телеграм
					</button>
				</div>
				<hr>
				<div class="fields__item">
					<button v-if="user.google" class="btn btn--lg btn--outline-google btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-google"></use></svg>
						{{ user.google.username }}
					</button>
					<button v-if="!user.google" @click="$root.OAuth('google')" class="btn btn--lg btn--outline-google btn--block">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-google"></use></svg>
						Привязать Google
					</button>
				</div>
				<hr>
				<div class="fields__item">
					<button type="submit" class="btn btn--lg btn--outline-danger btn--block" @click="logout">Выйти из аккаунта</button>
				</div>
			</div>
		</Modal>
    </div>
</template>

<script>

	import { mapState } from 'pinia'
	import { useUserStore } from '../../stores/User'
	import Modal from "../blocks/Modal.vue";

    export default {
		components: {Modal},
        data() {
            return {
                oldPassword: '',
                newPassword: '',
                username: '',
                setPass: '',
                // refbackPercent: this.user.refback_percent,
                errors: {
                    show: false,
                    message: ''
                },
                errors1: {
                    show: false,
                    message: ''
                },
                errors2: {
                    show: false,
                    message: ''
                },
                // refbackErrors: {
                //     show: false,
                //     message: ''
                // },
                disableBtn: false,
                successChangePassword: false,
                disableBtn1: false,
                successChangeNick: false,
                disableBtn2: false,
                successSetPass: false,
                // refbackDisableBtn: false,
                // successChangeRefback: false,
				show: false
            }
        },

		mounted() {
			this.$root.emitter.on('showUserSettings', state => this.show = !!state);
		},

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            logout() {
                this.$root.axios.post('api/auth/logout')
                .then(async (res) => {
                    await this.$root.wsLogoutUser();

                    this.user = null;

                    this.$cookie.delete('token');

                    this.show = false;
                    
                    if(this.$router.currentRoute.name !== 'index') {
                        this.$router.push({ name: 'index' });
                    }
                });
            },
            resetPassword() {
                if (!this.oldPassword) {
                    return this.$toast.error('Введите старый пароль');
                }

                if (!this.newPassword) {
                    return this.$toast.error('Введите новый пароль');
                }

                this.disableBtn = true;

                this.$root.axios.post('api/user/password/change', {
                    current_password: this.oldPassword,
                    new_password: this.newPassword
                }).then((response) => {
                    if (response.data.success) {
                        this.disableBtn = false;
                        this.successChangePassword = true;                    
                    }
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));

                    this.disableBtn = false;
                });
            },
            editUser() {
                if (!this.username) {
                    return this.$toast.error('Введите новый ник');
                }

                this.disableBtn1 = true;

                this.$root.axios.post('api/user/username', {
                    'username': this.username
                }).then((response) => {
                    const data = response.data;
                    if (data.success) {
                        this.disableBtn1 = false;
                        this.successChangeNick = true;
                        this.$root.getUser();                        
                    } else {
                        this.$toast.error(data.message);
                    }
                })
                .catch(error => {
                    this.disableBtn1 = false;

                    this.$toast.error(this.$root.graphql.axiosGetError(error));

                    this.disableBtn = false;
                });
            },
            setPassword() {
                if (!this.setPass) {
                    return this.$toast.error('Введите новый пароль');
                }

                this.disableBtn2 = true;

                this.$root.axios.post('api/user/password/set', {
                    password: this.setPass
                }).then((response) => {
                    if (response.data.success) {
                        this.disableBtn2 = false;
                        this.successSetPass = true;    
                        this.$root.getUser();                 
                    }
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                    
                    this.disableBtn2 = false;
                });
            },
        }
    }
</script>
